<div [class.collapsed]="isCollapsed$ | async"
     [class.dropdown-open]="dropdownOpen$ | async"
     [ngClass]="levelClass"
     class="sidenav-item">
     <ng-container *ngIf="isCategory()">
        <div *ngIf="returnValueCategory('categoryType') === 'subheading'" [ngClass]="returnValueCategory('categoryCustomClass') ?? ''"
          class="subheading">{{ returnValueCategory('categoryName') }}
        </div>
     </ng-container>
     <ng-container *ngIf="isItem()">
        <div *ngIf="returnValueItem('itemType') === 'subheading'" [ngClass]="returnValueItem('itemCustomClass') ?? ''"
          class="subheading">{{ returnValueItem('itemName') }}
        </div>
      </ng-container>

  <ng-container *ngIf="isCategory()">
    <ng-container *ngIf="returnValueCategory('categoryType') !== 'subheading'">
      <ng-container *ngIf="hasSubItems(item) || isFunction(returnValueCategory('categoryRouteOrFunction')); then functionOrSubItems; else link"></ng-container>
    </ng-container>


    <ng-template #functionOrSubItems>
      <a (click)="handleClick()"
        class="sidenav-item-link"
        fxLayout="row"
        fxLayoutAlign="start center"
        matRipple>
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    </ng-template>

    <ng-template #link>
      <a [routerLinkActiveOptions]="{ exact: returnActiveCategory('itemRouteOrFunction') || false }"
        [routerLink]="returnValueCategory('categoryRouteOrFunction')"
        class="sidenav-item-link"
        fxLayout="row"
        fxLayoutAlign="start center"
        matRipple
        routerLinkActive="active">
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    </ng-template>

    <ng-template #linkContent>
      <mat-icon *ngIf="level === 0" class="icon">{{ returnValueCategory('categoryIcon') }}</mat-icon>
      <div *ngIf="level > 0" class="text-icon" fxFlex="none">{{ getTextIcon(item) }}</div>
      <span class="name">{{ returnValueCategory('categoryName') }}</span>
      <span fxFlex><!-- fill space --></span>
      <span *ngIf="returnValueCategory('categoryBadge')" [style.background-color]="returnValueCategory('categoryBadgeColor')" class="badge">{{ returnValueCategory('categoryBadge') }}</span>
      
      <mat-icon *ngIf="hasSubItems(item)" [class.rotate]="dropdownOpen$ | async"
                class="expand-indicator">
        expand_more
      </mat-icon>
    </ng-template>

    <div [@dropdownOpen]="dropdownOpen$ | async" class="dropdown" fxLayout="column">
      <ng-container *ngIf="returnValueCategory('items')">
        <app-sidenav-item *ngFor="let subItem of returnValueCategory('items')" [item]="subItem" [level]="level+1"></app-sidenav-item>
      </ng-container>
    </div>

  </ng-container>

  <ng-container *ngIf="isItem()">
    <ng-container *ngIf="returnValueItem('itemType') !== 'subheading'">
      <ng-container *ngIf="hasSubItems(item) || isFunction(returnValueItem('itemRouteOrFunction')); then functionOrSubItems; else link"></ng-container>
    </ng-container>


    <ng-template #functionOrSubItems>
      <a (click)="handleClick()"
        class="sidenav-item-link"
        fxLayout="row"
        fxLayoutAlign="start center"
        matRipple>
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    </ng-template>

    <ng-template #link>
      <a [routerLinkActiveOptions]="{ exact: returnActiveItem('itemRouteOrFunction') || false }"
        [routerLink]="returnValueItem('itemRouteOrFunction')"
        class="sidenav-item-link"
        fxLayout="row"
        fxLayoutAlign="start center"
        matRipple
        routerLinkActive="active">
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    </ng-template>

    <ng-template #linkContent>
      <mat-icon *ngIf="level === 0" class="icon">{{ returnValueItem('itemIcon') }}</mat-icon>
      <div *ngIf="level > 0" class="text-icon" fxFlex="none"> - </div>
      <span class="name">{{ returnValueItem('itemName') }}</span>
      <span fxFlex><!-- fill space --></span>
      <span *ngIf="returnValueItem('itemBadge')" [style.background-color]="returnValueItem('itemBadgeColor')" class="badge">{{ returnValueItem('itemBadge') }}</span>
      
      <mat-icon *ngIf="hasSubItems(item)" [class.rotate]="dropdownOpen$ | async"
                class="expand-indicator">
        expand_more
      </mat-icon>
    </ng-template>

  </ng-container>

</div>
